import * as React from 'react'
import type {SVGProps} from 'react'
const SvgHint = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={72} height={80} viewBox="0 0 72 80" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M36 0c19.882 0 36 15.355 36 34.354 0 15.499-10.685 28.377-25.109 32.755l-8.184 11.52A3.31 3.31 0 0 1 36 80.002c-1.085 0-2.102-.514-2.712-1.373l-8.184-11.52C10.69 62.73 0 49.862 0 34.354 0 15.364 16.1 0 36 0m0 6.25c-16.243 0-29.453 12.61-29.453 28.104 0 13.017 9.221 23.788 21.495 27.067a3.3 3.3 0 0 1 1.824 1.257L36 71.314l6.13-8.636a3.3 3.3 0 0 1 1.828-1.257c12.26-3.274 21.5-14.035 21.5-27.067C65.458 18.859 52.243 6.25 36 6.25M35.976 40c2.256 0 4.022 1.901 4.022 4.027s-1.766 3.975-4.022 3.975c-2.208 0-3.98-1.848-3.98-3.975S33.768 40 35.976 40m.049-24c2.323 0 3.974 1.008 3.974 2.016v16.008c0 1.176-1.65 1.978-3.974 1.978-2.218 0-4.027-.802-4.027-1.978V18.017c0-1.008 1.81-2.016 4.027-2.016z"
        />
    </svg>
)
export default SvgHint
